<div class="lm-genai-prompt-div">
  <div class="lm-genai-prompt-prompt-div">
    <label
        class="lm-genai-prompt-label"
        soho-label
        [required]="true"
        for="prompt"
    >{{ 'KeyPointsLabel' | translate }}</label>
    <textarea
        name="prompt"
        soho-textarea
        placeholder="{{ 'GenAIPlaceholderText' | translate }}"
        class="lm-genai-prompt-textarea"
        data-automation-id="lm-genai-input"
        (input)="onInput($event)"
        attr.data-validate="required"
        [(ngModel)]="genAIPrompt.value"
        attr.aria-label="{{ 'KeyPoints' | translate }}">
    </textarea>
    <button #generateButton
        data-automation-id="lm-genai-button"
        class="btn-primary btn-generative lm-genai-prompt-button"
        [disabled]="!valid"
        (click)="onGenerateClickEvent($event)"
    >{{ 'GenerateAIButton' | translate }}
      <svg soho-icon icon="insights-smart-panel"></svg>
    </button>
  </div>
  <div class="editor-container is-readonly lm-genai-prompt-editor-container">
    <div *ngIf="isGeneratedError" id="generated-error" class="error-message" style="font-size:14px; max-width:500px" data-automation-id="lm-genai-prompt-generated-alert">
      <svg class="icon-error icon" focusable="false" aria-hidden="true" role="presentation">
        <use href="#icon-error"></use>
      </svg>
      <pre class="audible">{{generatedErrorMessage}}</pre>
      <p class="message-text">{{generatedErrorMessage}}</p>
    </div>
    <label
        class="lm-genai-prompt-label"
        soho-label
        for="generatedText"
    >{{ 'GeneratedAITextLabel' | translate }}</label>
    <div
        name="generatedText"
        soho-editor
        disabled="true"
        class="lm-genai-prompt-editor"
        soho-alert
        data-automation-id="lm-genai-text"
        [(ngModel)]="genAIResponse.value"
        attr.aria-label="{{ 'GenAI' | translate }}">
    </div>
    <div id="disclaimer" class="custom-icon-message" data-automation-id="lm-genai-prompt-generated-alert">
      <svg class="icon-custom icon" focusable="false" aria-hidden="true" role="presentation">
        <use href="#icon-info"></use>
      </svg>
      <pre class="audible">{{disclaimerMessage}}</pre>
      <p class="message-text">{{disclaimerMessage}}</p>
    </div>
  </div>
</div>
